import { Fragment } from 'react'

import HeadLine from './head-line'
import AboutMe from './about-me'
import ContractMe from './contract-me'
import Publication from './publication'
import Footer from './footer'

export default function Home(){
    return (
        <Fragment>
            <HeadLine />
            <AboutMe />
            <ContractMe />
            <Publication />
            <Footer />
        </Fragment>
        )
}
